import { call, put, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchOtherCompanies,
    otherCompaniesFetched,
    otherCompaniesFetchRequestFailed,
} from '../otherCompanies';

function* fetchOtherCompaniesEffect({ payload }) {
    try {
        // NOTE: unlike the approved-companies saga, the globally-selected province is
        // deliberately NOT applied here. This screen lists companies OUTSIDE the
        // serviced provinces, so injecting the global province (e.g. Ontario) would
        // always return zero rows.
        const response = yield call(SendApiRequest, {
            url: apiRoutes.users,
            method: 'GET',
            queryParams: payload,
        });
        yield put(
            otherCompaniesFetched({
                results: response.results,
                totalRecords: response.totalRecords,
            }),
        );
    } catch (e) {
        yield put(otherCompaniesFetchRequestFailed());
    }
}

export const otherCompaniesSagas = [
    takeLatest(fetchOtherCompanies.type, fetchOtherCompaniesEffect),
];
